import { MULTICODEC_IDENTIFY, MULTICODEC_IDENTIFY_PUSH } from './consts.js';
import { DefaultIdentifyService } from './identify.js';
import { Identify } from './pb/message.js';
/**
 * The protocols the IdentifyService supports
 */
export const multicodecs = {
    IDENTIFY: MULTICODEC_IDENTIFY,
    IDENTIFY_PUSH: MULTICODEC_IDENTIFY_PUSH
};
export const Message = { Identify };
export function identifyService(init = {}) {
    return (components) => new DefaultIdentifyService(components, init);
}
//# sourceMappingURL=index.js.map